import { __ } from "@wordpress/i18n/build";
import SbUtils from "../../../../../Utils/SbUtils";
import Button from "../../../../Common/Button";
import CollectionEmpty from "./CollectionEmpty";
import CollectionReviewsList from "./CollectionReviewsList";
import FullScreenContainer from "./Form/FullScreenContainer";
import { useContext, useState } from "react";
import Input from "../../../../Common/Input";
import RedirectingModal from "../../../../Modals/RedirectingModal";

const Collection = () => {

	const currentContext = SbUtils.getCurrentContext();
    const {
		sbCustomizer,
		curCl,
        slSection,
		editorTopLoader,
		editorNotification,
        slFullScreen,
		sources,
		collectionRv,
		collectionP,
		revSearch
    } = useContext( currentContext );

	const [ editCollectionNameActive, setEditCollectionNameActive] = useState(false);
	const [ createFeedRedirectModal, setCreateFeedRedirectModal] = useState(false);

	const updateCollectionName = () => {
		const formData = {
            	action : 'sbr_feed_saver_manager_update_collection_name',
				collection_name : curCl?.currentCollection?.name,
				provider_id : curCl?.currentCollection?.account_id,
				id : curCl?.currentCollection?.id,
				provider : curCl?.currentCollection?.provider
			},
            notificationsContent = {
                success : {
                    icon : 'success',
         			text : __('Collection Name Updated', 'reviews-feed' )
               }
        }
		if (SbUtils.checkNotEmpty(curCl?.currentCollection?.name)) {
			SbUtils.ajaxPost(
				sbCustomizer.ajaxHandler,
				formData,
				( data ) => { //Call Back Function
					if(data?.newCollectionData) {
						curCl?.setCurrentCollection(data?.newCollectionData)
					}
					if(data?.sourcesList) {
						sources.setSourcesList(data?.sourcesList)
					}
					setEditCollectionNameActive(false)
				},
				editorTopLoader,
				editorNotification,
				notificationsContent
			)
		}
	}

	const createNewCollectionFeed = () => {
        const formData = {
			action : 'sbr_feed_saver_manager_builder_update',
            new_insert : true,
			feed_name : curCl?.currentCollection?.name,
            feedTemplate : 'default',
            sources : JSON.stringify([curCl?.currentCollection?.account_id])
        };
		setCreateFeedRedirectModal(true);
		setTimeout(() => {
			SbUtils.ajaxPost(
				sbCustomizer.ajaxHandler,
				formData,
				( data ) => { //Call Back Function
					localStorage.setItem('newCreatedFeed', data.feed_id);
					window.location.href = sbCustomizer.builderUrl + '&feed_id=' + data.feed_id;
				},
				null,
				null,
				null
			)
		}, 3500);
	}

	return (
		<section className='sb-full-wrapper sb-fs'>
			<section className='sb-small-wrapper'>
				<div className='sb-scollection-top sb-fs'>
					<div className='sb-scollection-heading-ctn'>
						<strong
							className='sb-scollection-heading-back sb-small-p sb-bold sb-svg-i'
							onClick={() => {
								slSection.setCollectionSectionActive('list')
								collectionP.setCollectionReviewsPage(1)
							}}
						>
							{SbUtils.printIcon('chevron-left', '', false, 7)}
							{__('Back to All Collections','reviews-feed')}
						</strong>
						<h2
							className='sb-scollection-heading sb-h2'
							data-active={editCollectionNameActive}
							onClick={() => {
								setEditCollectionNameActive(true)
							}}
						>
							{
								!editCollectionNameActive &&
								<>
									<span>
										{ curCl?.currentCollection?.name }
									</span>
									<Button
										customClass='sb-scollection-heading-edit-btn'
										size='medium'
										icon='pen'
										boxshadow='false'
										tooltip={__('Rename','reviews-feed')}
									/>
								</>
							}
							{
								editCollectionNameActive &&
								<div
									className='sb-scollection-headinp'
									title={__('Update the Collection Name','reviews-feed')}
								>
									<Input
										size='large'
										type='text'
										value={curCl?.currentCollection?.name}
										onChange={(event) => {
											curCl.setCurrentCollection({
												...curCl?.currentCollection,
												name : event.currentTarget.value
											})
										}}
										onKeyUp={(event) => {
											if( event.keyCode === 13 ) {
												updateCollectionName()
											}
										}}
									/>
									<Button
										type='primary'
										size='medium'
										icon='success'
										onClick={() => {
											updateCollectionName()
										}}
									/>
								</div>
							}
						</h2>
					</div>
					<div className='sb-scollection-top-actions'>
						<Button
							type='secondary'
							size='small'
							icon='templates'
							iconSize='11'
							text={ __( 'Create Feed', 'reviews-feed' ) }
							onClick={ () => {
								createNewCollectionFeed()
							} }
						/>
						<Button
							type='primary'
							size='small'
							icon='plus'
							iconSize='11'
							text={ __( 'Add Review', 'reviews-feed' ) }
							onClick={ () => {
								slFullScreen.setCollectionFullScreen(true)
							} }
						/>
					</div>
				</div>


				<div className='sb-scollection-content sb-fs'>
					{
						(
							collectionRv?.collectionReviewsList.length > 0 ||
							(collectionRv?.collectionReviewsList.length === 0 && revSearch.showReviews !== 'all')
						) &&
						<CollectionReviewsList/>
					}
					{
						collectionRv?.collectionReviewsList.length === 0 && revSearch.showReviews === 'all' &&
						<CollectionEmpty/>
					}
				</div>
				{
					slFullScreen.collectionFullScreen &&
					<FullScreenContainer/>
				}
			</section>
			{
				createFeedRedirectModal &&
				<RedirectingModal
					heading={__('Redirecting to Feed Editor','reviews-feed')}
					text={__('We have created a feed and added this collection as a source.','reviews-feed')}
				/>
			}
		</section>
	)

}

export default Collection;